import { SVGProps } from 'react';

export const NoData = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="300"
      height="300"
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.8">
        <rect
          opacity="0.32"
          x="28.4961"
          y="27.5"
          width="245.18"
          height="245.18"
          rx="122.59"
          fill="#E5E5E5"
        />
        <path
          d="M252.745 88.293L252.745 219.854C252.745 223.156 250.068 225.833 246.766 225.833L55.4053 225.833C52.1029 225.833 49.426 223.156 49.4258 219.854L49.4258 88.293C49.4258 84.9904 52.1028 82.3136 55.4053 82.3135L246.766 82.3135C250.068 82.3135 252.745 84.9904 252.745 88.293Z"
          fill="white"
          stroke="#666666"
          strokeWidth="1.99333"
        />
        <path
          d="M252.745 88.2949L252.745 92.2812C252.745 95.5839 250.068 98.2617 246.766 98.2617L55.4053 98.2617C52.1027 98.2616 49.4258 95.5838 49.4258 92.2812L49.4258 88.2949C49.4258 84.9924 52.1028 82.3156 55.4053 82.3154L246.766 82.3154C250.068 82.3155 252.745 84.9923 252.745 88.2949Z"
          fill="#E5E5E5"
          stroke="#666666"
          strokeWidth="1.99333"
        />
        <path
          d="M75.5928 90.29C75.5928 92.0824 74.14 93.5359 72.3477 93.5361L64.374 93.5361C62.5815 93.5361 61.1289 92.0825 61.1289 90.29C61.1291 88.4977 62.5817 87.0449 64.374 87.0449L72.3477 87.0449C74.1399 87.0451 75.5926 88.4978 75.5928 90.29Z"
          fill="#F2F3F4"
          stroke="#666666"
          strokeWidth="1.48222"
        />
        <path
          d="M96.5234 90.29C96.5234 92.0824 95.0706 93.5359 93.2783 93.5361L85.3047 93.5361C83.5122 93.5361 82.0596 92.0825 82.0596 90.29C82.0598 88.4977 83.5123 87.0449 85.3047 87.0449L93.2783 87.0449C95.0705 87.0451 96.5233 88.4978 96.5234 90.29Z"
          fill="#F2F3F4"
          stroke="#666666"
          strokeWidth="1.48222"
        />
        <path
          d="M117.452 90.29C117.452 92.0824 115.999 93.5359 114.207 93.5361L106.233 93.5361C104.441 93.5361 102.988 92.0825 102.988 90.29C102.988 88.4977 104.441 87.0449 106.233 87.0449L114.207 87.0449C115.999 87.0451 117.452 88.4978 117.452 90.29Z"
          fill="#F2F3F4"
          stroke="#666666"
          strokeWidth="1.48222"
        />
        <circle
          opacity="0.34"
          cx="150.284"
          cy="158.59"
          r="40.8356"
          fill="#EAEAEA"
        />
        <g opacity="0.8">
          <path
            d="M150.849 179.908L167.863 170.098L161.337 166.335L154.668 170.179C154.611 170.211 154.547 170.227 154.482 170.227C154.417 170.226 154.353 170.209 154.296 170.176C154.24 170.144 154.193 170.097 154.16 170.041C154.128 169.985 154.11 169.921 154.109 169.856V160.719C154.109 160.588 154.144 160.459 154.209 160.346C154.275 160.232 154.369 160.138 154.483 160.073L162.406 155.504C162.463 155.472 162.528 155.455 162.593 155.455C162.658 155.456 162.722 155.473 162.779 155.506C162.835 155.538 162.883 155.585 162.915 155.641C162.948 155.697 162.966 155.761 162.967 155.827V163.514L169.492 167.276V147.656L150.849 158.406V179.908Z"
            fill="#434343"
          />
          <path
            d="M152.481 137.846V145.372L159.147 149.215C159.203 149.248 159.25 149.295 159.282 149.352C159.314 149.408 159.331 149.472 159.331 149.537C159.331 149.602 159.314 149.666 159.282 149.723C159.25 149.779 159.203 149.826 159.147 149.86L151.224 154.429C151.11 154.494 150.981 154.529 150.85 154.529C150.719 154.529 150.59 154.494 150.476 154.429L142.552 149.864C142.496 149.831 142.449 149.784 142.417 149.727C142.385 149.67 142.368 149.607 142.368 149.541C142.368 149.476 142.385 149.412 142.417 149.356C142.449 149.299 142.496 149.252 142.552 149.219L149.218 145.376V137.846L132.203 147.656L150.849 158.406L169.495 147.656L152.481 137.846Z"
            fill="#434343"
          />
          <path
            d="M147.03 170.18L140.36 166.335L133.835 170.098L150.849 179.908V158.406L132.203 147.656V167.276L138.729 163.514V155.825C138.73 155.76 138.748 155.697 138.781 155.641C138.814 155.585 138.861 155.538 138.918 155.506C138.974 155.474 139.038 155.456 139.103 155.456C139.168 155.456 139.232 155.472 139.289 155.504L147.218 160.073C147.331 160.138 147.425 160.232 147.491 160.346C147.556 160.459 147.591 160.588 147.59 160.719V169.856C147.59 169.921 147.573 169.986 147.54 170.042C147.507 170.099 147.46 170.146 147.403 170.179C147.347 170.212 147.282 170.229 147.217 170.229C147.151 170.229 147.087 170.212 147.03 170.18Z"
            fill="#434343"
          />
        </g>
      </g>
    </svg>
  );
};
